// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border[data-v-4d7485f4]{--border-opacity:1;border-color:#b2b2b2;border-color:rgba(178,178,178,var(--border-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
